import {
  TextBox,
  Select,
  Button,
} from "@veneer/core";
import React, { useState } from "react";
import ConnectAPI from "../../services/api";
import Swal from "sweetalert2";
import { authenticationService } from "../../services/context/AuthService";
import axios from 'axios';

function formatName(name) {
  name = name.replace(/  +/g, " ");
  let formated = "";
  const arr = name.split(" ");
  //console.log(arr);
  let namePart = "";
  let namePartArr;

  for (var i = 0; i < arr.length; i++) {
    namePartArr = arr[i].split("");
    for (var j = 0; j < namePartArr.length; j++) {
      namePart +=
        j == 0 ? namePartArr[j].toUpperCase() : namePartArr[j].toLowerCase();
    }

    formated += namePart + (i + 1 < arr.length ? " " : "");
    namePart = "";
  }

  return formated;
}

const connectApi = new ConnectAPI();

const UserInfoForm = (props) => {
  const [jobPosition, setJobPosition] = useState([]);
  const [jobPositionOther, setJobPositionOther] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("currentUser"));
  const isHPEmployee = user.email.endsWith("@hp.com");

  const jobPositionSelect = (
    <div>
      <Select
        id="jobPosition"
        options={[
          { value: "General Manager", label: "General Manager" },
          { value: "Operations Manager", label: "Operations Manager" },
          { value: "Owner", label: "Owner" },
          { value: "Sales Manager", label: "Sales Manager" },
          { value: "Sales Representative", label: "Sales Representative" },
          { value: "Technician", label: "Technician" },
          { value: "Other", label: "Other" },
        ]}
        label="Job Position"
        value={jobPosition}
        onChange={(e) => setJobPosition([e.value])}
        onClear={() => setJobPosition([])}
      />
      <br />
    </div>
  );

  const jobPositionInput = (
    <div>
      <TextBox
        id="jobPositionInput"
        label="Specify Job Position"
        value={jobPositionOther}
        onChange={(e) => setJobPositionOther(formatName(e))}
        maxLength="100"
      />
      <br />
    </div>
  );
function saveUserInfo() {
  setIsLoading(true);

  let tokenValue = "";
  
  try {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    tokenValue = currentUser?.token?.key || "";
  } catch (e) {
    console.error("Error parsing user from localStorage:", e);
  }

  axios.post(
    "api/account/UpdateUserInfo",
    {
      idUser: user.idUser,
      name: user.name,
      jobPosition: jobPositionOther.length > 0 ? jobPositionOther : jobPosition[0],
    },
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': `Bearer ${tokenValue}`
      }
    }
  )
  .then((response) => {
    setIsLoading(false);
    handleResponse(response.status, response.data);
  })
  .catch((error) => {
    setIsLoading(false);
    console.error("Error updating user info:", error);
    let errorMessage = error.response?.data || error.message || "An error occurred while updating.";
    Swal.fire("Error", typeof errorMessage === 'string' ? errorMessage : JSON.stringify(errorMessage), "error");
  });
}
 /* function saveUserInfo() {
    setIsLoading(true);
    connectApi.post("api/account/UpdateUserInfo",{
       idUser: user.idUser,
            name: user.name,
            jobPosition:
              jobPositionOther.length > 0 ? jobPositionOther : jobPosition[0],
    }).then(response=>{
      handleResponse(response.status, response.data);
    }).catch((error)=>{
        setIsLoading(false);
        console.log(error);
        Swal.fire(
          error.response ? "Error " + error.response.status : "Error",
          error.response && error.response.data ? error.response.data : "An error occurred",
          "error"
        );
        return;
      })
    /*connectApi
      .get(
        "api/account/UpdateUserInfo",
        {
          params: {
            idUser: user.idUser,
            name: user.name,
            jobPosition:
              jobPositionOther.length > 0 ? jobPositionOther : jobPosition[0],
          },
        },
        handleResponse
      )
      .catch((error) => {
        setIsLoading(false);
        console.log(error);
        Swal.fire(
          "Error " + error.response?.status,
          error.response?.data,
          "error"
        );
        return;
      });
  }*/
   
  function handleResponse(status, data) {
    setIsLoading(false);
    var userData = data;
    userData.loginDate = new Date();
    authenticationService.login(userData);
  }

  function validateForm() {
    const jobPositionState =
      jobPosition.length == 0
        ? false
        : jobPosition[0].length > 0
          ? jobPosition[0] != "Other"
            ? true
            : jobPositionOther.length > 0
          : false;

    return jobPositionState; //error state belongs to the state of the password field
  }

  return (
    <div>
      <div>
        <h6 className="mt-0 mb-2">
          You are logging in on behalf of the company <b>{user.companyName}.</b>{" "}
          If this is not your company, please contact us sending an email to{" "}
          <a href="mailto:ipsp@hp.com?subject=Password%20Request">
            ipsp@hp.com
          </a>{" "}
          to report the issue. Otherwise, please provide de following
          information.
        </h6>
        <br />
      </div>
      {isHPEmployee ? "" : jobPositionSelect}
      {jobPosition == "Other" ? jobPositionInput : ""}
      <br />
      <Button
        loading={isLoading}
        type="submit"
        onClick={saveUserInfo}
        expanded={true}
        disabled={!validateForm()}
      >
        Save
      </Button>
    </div>
  );
};

export default UserInfoForm;
